import { useEffect, ReactNode } from "react";
import { useUID } from "../../../core/auth/useLoggedInUser";
import { AssigneeSelection } from "../../../core/components/widgets/AssigneeSelection";
import trackerHelper from "../../../helpers/tracker";
import { useLastAssignedTeamForItem } from "@coworker/apprestructured/src/tasks/hooks/useLastAssignedTeamForItem";

type Assignee = {
  gid?: string | undefined;
  uid?: string | undefined;
};

type ValueProp = {
  gid?: string | undefined;
  uid?: string | undefined;
  productId: string;
  refilled_by_me: boolean;
};

interface TaskFormAssignProps {
  value: ValueProp;
  onChange: ({ gid, uid }: Assignee) => null;
  conf: {
    icon: ReactNode;
    deactivated: boolean;
    testId: string;
  };
  additionalSubTitle?: React.ReactNode | undefined;
}

/**
 * @deprecated Perhaps prefer AssignToWidget
 */
export default function TaskFormAssign({
  value,
  onChange,
  conf,
  additionalSubTitle,
}: TaskFormAssignProps) {
  const { data: lastAssignedTeam, isLoading } = useLastAssignedTeamForItem(
    value.productId
  );
  const profileUid = useUID();

  const { icon, deactivated, testId } = conf;
  const { gid, uid, refilled_by_me } = value;

  useEffect(() => {
    // Auto-assign only if assignment was not already made.
    // If gid is already set, do not overwrite, instead ignore the fetched best guess.
    if (!isLoading && lastAssignedTeam) {
      const gidBestGuess = lastAssignedTeam?.id;
      if (!gid && gidBestGuess) {
        trackerHelper.taskEfficiency.trackTeamChange(); // Track team change
        onChange({ gid: gidBestGuess }); // Auto-assign the team
      }
    }
  }, [isLoading, lastAssignedTeam, onChange, gid]);

  return (
    <AssigneeSelection
      tabIndex={0}
      selectedTeamId={gid}
      selectedUserId={refilled_by_me ? profileUid : uid}
      onConfirm={onChange}
      image={icon}
      testId={testId ? testId : "assignWidget"}
      disabled={deactivated}
      shortId={value.productId}
      additionalSubTitle={
        !value.gid || !value.uid || !value.refilled_by_me ? (
          additionalSubTitle
        ) : (
          <></>
        )
      }
    />
  );
}
